import { informationsRouteList } from "../../App";
import { usePwaViewportWidth } from "../../hooks/useScreenWidth";
import { RootContainer } from "../../styles/Container.style";
import { Image, LinkOvl } from "../Informations.page";

export default function EnrichmentExercisesPage() {
  const viewportWidth = usePwaViewportWidth();
  return (
    <RootContainer $alignItem="center">
      <Image $width={viewportWidth + "px"} src="/informations/tips-and-advices.png" />
      {/* Exercices */}
      <LinkOvl
        to={
          "https://www.bluecross.org.uk/advice/dog/running-with-your-dog?gad_source=1&gclid=CjwKCAjwwe2_BhBEEiwAM1I7sZIZdhawFkuSQAr6mI6yQRcVg-VLGWRttjN8EFhaLZsh6l5ued-jNBoCyHQQAvD_BwE"
        }
        target="_blank"
        rel="noopener noreferrer"
        $top={23}
        $left={17}
        $width={21}
        $height={5}
      />
      <LinkOvl
        to={"https://www.akc.org/expert-advice/training/exercises-canine-conditioning/"}
        target="_blank"
        rel="noopener noreferrer"
        $top={23}
        $left={40}
        $width={25}
        $height={5}
      />
      <LinkOvl
        to={"https://www.rspca.org.uk/adviceandwelfare/pets/dogs/training/leave"}
        target="_blank"
        rel="noopener noreferrer"
        $top={23}
        $left={67}
        $width={8}
        $height={5}
      />
      <LinkOvl
        to={"https://www.battersea.org.uk/pet-advice/dog-advice/how-teach-dog-stay"}
        target="_blank"
        rel="noopener noreferrer"
        $top={23}
        $left={76}
        $width={5}
        $height={5}
      />
      {/* Walks */}
      <LinkOvl
        to={"https://www.bluecross.org.uk/advice/dog/behaviour-and-training/life-on-a-lead"}
        target="_blank"
        rel="noopener noreferrer"
        $top={31}
        $left={10}
      />
      {/* Games */}
      <LinkOvl
        to={"https://www.battersea.org.uk/pet-advice/dog-advice/brain-games-dogs"}
        target="_blank"
        rel="noopener noreferrer"
        $top={45}
        $left={20}
        $width={16}
        $height={2}
      />
      <LinkOvl
        to={"https://www.bluecross.org.uk/advice/dog/how-to-make-a-destruction-box"}
        target="_blank"
        rel="noopener noreferrer"
        $top={45}
        $left={37}
        $width={18}
        $height={2}
      />
      <LinkOvl
        to={"https://www.rspca.org.uk/adviceandwelfare/costofliving/diypetgames"}
        target="_blank"
        rel="noopener noreferrer"
        $top={45}
        $left={57}
        $width={14}
        $height={2}
      />
      <LinkOvl
        to={"https://www.akc.org/expert-advice/training/indoor-scent-games-for-dogs/"}
        target="_blank"
        rel="noopener noreferrer"
        $top={45}
        $left={72}
        $width={8}
        $height={2}
      />
      <LinkOvl
        to={"https://www.akc.org/expert-advice/training/indoor-scent-games-for-dogs/"}
        target="_blank"
        rel="noopener noreferrer"
        $top={47}
        $left={26}
        $width={10}
        $height={2}
      />
      <LinkOvl
        to={
          "https://www.bluecross.org.uk/advice/dog/food-and-weight/top-10-kong-recipes-for-dogs?amp=&gad_source=1&gclid=CjwKCAjwwe2_BhBEEiwAM1I7sTp7vbX67S424uzsAuQjCkHdyN61nsQ2eW-cqMBAoGKla0Mp-AKLfBoCwI4QAvD_BwE"
        }
        target="_blank"
        rel="noopener noreferrer"
        $top={47}
        $left={37}
        $width={13}
        $height={2}
      />
      <LinkOvl
        to={"https://www.bluecross.org.uk/advice/dog/behaviour-and-training/dogs-and-chewing"}
        target="_blank"
        rel="noopener noreferrer"
        $top={47}
        $left={52}
        $width={21}
        $height={2}
      />
      <LinkOvl
        to={informationsRouteList.dogBodyLanguage}
        target="_blank"
        rel="noopener noreferrer"
        $top={70}
        $left={51}
        $width={6}
        $height={2}
      />
    </RootContainer>
  );
}
